<svg
  width="16"
  height="10"
  viewBox="0 0 16 10"
  xmlns="http://www.w3.org/2000/svg"
  class="app-icon"
  [ngClass]="{'is-active': active}"
>
  <path
    d="M15.2929 3.04028L8.70711 9.62606C8.31658 10.0166 7.68342 10.0166 7.29289 9.62606L0.707106 3.04028C0.316582 2.64975 0.316583 2.01659 0.707107 1.62606L1.95956 0.37361C2.35008 -0.0169141 2.98325 -0.0169134 3.37377 0.373611L7.29289 4.29273C7.68342 4.68325 8.31658 4.68325 8.70711 4.29273L12.6262 0.373611C13.0168 -0.0169137 13.6499 -0.0169131 14.0404 0.373611L15.2929 1.62606C15.6834 2.01659 15.6834 2.64975 15.2929 3.04028Z"/>
</svg>
